import {
  CardContainer,
  EntityGroupWorkflowCard,
  EntityGroupWorkflowCardFooter,
  flowsQuery,
  useEnvironment,
  useFlowActions,
} from '@diana/core';
import { IFlow } from '@diana/core/build/models/Flow';
import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { routeUrls } from '../../app/Routing/RouteUrls';
import { WORKFLOWS_PAGE_NS } from './i18n';
import { SxProps } from '@mui/system';

export const WorkflowCard = (props: {
  flow: IFlow;
  refetch: () => void;
  setProcessing: (status: boolean) => void;
  totalItems?: number;
  isFetching?: boolean;
  containerSx?: SxProps;
}) => {
  const { t } = useTranslation(WORKFLOWS_PAGE_NS);
  const { flow, containerSx = {}, totalItems, isFetching } = props;
  const environment = useEnvironment();
  const { id: flowId, imageUrl, displayName, icon } = flow;

  const { actions, headerActionsElement } = useFlowActions({
    flowsQuery,
    ...props,
    actions: {
      edit: { title: flow.draftFlowId ? t('actions.continueEditing') : t('actions.edit') },
      version: { title: t('actions.showVersion') },
    },
  });

  const iconValue = { imageUrl, icon: icon?.shape ?? '', color: icon?.color ?? '' };

  const Footer = useMemo(() => {
    return <EntityGroupWorkflowCardFooter totalItems={totalItems || 0} isFetching={isFetching} />;
  }, [totalItems, isFetching]);

  return (
    <Fragment>
      <CardContainer sx={containerSx}>
        <EntityGroupWorkflowCard
          href={routeUrls.workboard.url({ environment, flowId }, null)}
          title={displayName}
          subTitle=""
          actions={actions}
          headerActions={headerActionsElement}
          footer={Footer}
          icon={iconValue}
        />
      </CardContainer>
    </Fragment>
  );
};
